import { render, staticRenderFns } from "./wyjf.vue?vue&type=template&id=7558535e&scoped=true&"
import script from "./wyjf.vue?vue&type=script&lang=js&"
export * from "./wyjf.vue?vue&type=script&lang=js&"
import style0 from "./wyjf.vue?vue&type=style&index=0&id=7558535e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7558535e",
  null
  
)

export default component.exports